// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../config/styles';

const styles = theme => ({
  errorMessage: {
    margin: '10px 0',
    padding: 5,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  },
  statusError: {
    color: GlobalStyles.color.COLOR_REJECT,
  },
  greenContainer: {
    width: 'calc(100% + 60px)',
    padding: '15px 0',
    backgroundColor: GlobalStyles.color.COLOR_GREEN,
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down(750)]: {
      width: 'calc(100% + 20px)',
    }
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.down(550)]: {
      flexDirection: 'column',
    },
  },
  button: {
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    color: GlobalStyles.color.COLOR_PRIMARY,
    padding: '15px 0',
    width: 250,
    margin: '10px',
    borderRadius: 15,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: 'none',
    '&:hover': {
      boxShadow: GlobalStyles.color.COLOR_SHADOW_HOVER,
    }
  },
  buttonTopText: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    color: GlobalStyles.color.COLOR_SECONDARY,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
  },
  buttonBottomText: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_GREY,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
  },

  helperContainer: {
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    margin: '10px 30px',
  },
  welcomePackContainer: {
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_GREY,
    padding: '0 30px',
    marginBottom: 20,
    width: '100%',
    [theme.breakpoints.down(650)]: {
      marginTop: 10,
      fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    },
  },
  welcomePackLink: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    color: GlobalStyles.color.COLOR_SECONDARY,
    cursor: 'pointer',
  },
  mapContainer: {
    width: '100%',
    margin: 10,
    minHeight: 300,
  },
  completeButton: {
    margin: '20px auto -10px auto',
  },
  linkButton: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  arangeCollectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleText: {
    marginTop: 20,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
  },
});

export default styles;
